<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Tríplice viral"
            description="Situação vacinal de crianças com Tríplice viral"
            url="/imunizacao/vacina-idade-certa"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Tríplice viral',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
